import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";

const ComplianceModal = ({ show, complianceText, onAgree }) => {
  const [checked, setChecked] = useState(false);

  return (
    <Modal show={show} backdrop="static" keyboard={false} centered size="md">
      <Modal.Header className="bg-primary text-white py-2">
        <Modal.Title className="fs-6">Compliance Agreement</Modal.Title>
      </Modal.Header>

      <Modal.Body className="py-1">
        <p className="mb-3 small">{complianceText}</p>
      </Modal.Body>

      <Form.Check
        type="checkbox"
        id="compliance-agree"
        label={
          <label htmlFor="compliance-agree">
            I have read the above and agree
          </label>
        }
        checked={checked}
        onChange={(e) => setChecked(e.target.checked)}
        className="small ml-3 mb-3 mt-2"
      />

      <Modal.Footer className="justify-content-end">
        <Button
          variant="primary"
          size="sm"
          disabled={!checked}
          onClick={onAgree}
        >
          Agree
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ComplianceModal;
